import { getCSSVariableValue } from "../../../../_metronic/assets/ts/_utils";
import { escapeODataString } from "../../../axios/odata";

export interface OrderFilterValues {
    search: string;
    experience: string[];
    sla: string[];
    status: string[];
    dateRange: {
        startDate: Date | null,
        endDate: Date | null
    };
    page: number;
    perPage: number;
    totalRows: number;
    loading: boolean;
    sortState: {
        field: string;
        direction: string;
    }
}


export const buildOrdersFilterQuery = (filterValues: OrderFilterValues, includeStatus: boolean) => {
    const filter = [];

    if (filterValues.search) {
        const search = escapeODataString(filterValues.search);
        filter.push(`(contains(Number, '${search}') or contains(Experience, '${search}') or contains(Sla, '${search}') or contains(Status, '${search}') or contains(ClientReference, '${search}'))`);
    }

    if (filterValues.experience && filterValues.experience.length > 0) {
        const parts = filterValues.experience.map((e) => `Experience eq '${escapeODataString(e)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    if (filterValues.sla && filterValues.sla.length > 0) {
        const parts = filterValues.sla.map((s) => `Sla eq '${escapeODataString(s)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    if (filterValues.dateRange && filterValues.dateRange.startDate && filterValues.dateRange.endDate) {
        filter.push(`Created ge ${filterValues.dateRange.startDate.toISOString()} and Created le ${filterValues.dateRange.endDate.toISOString()}`);
    }

    if (includeStatus && filterValues.status && filterValues.status.length > 0) {
        const parts = filterValues.status.map((s) => `Status eq '${escapeODataString(s)}'`);
        filter.push(`(${parts.join(' or ')})`);
    }

    const filterQuery = filter.length ? filter.join(' and ') : '';
    return filterQuery;
}


interface OrderStatusLabelColorClassName {
    status: string;
    label: string;
    color: string;
    className: string;
    classNameText: string;
}

export const ORDER_STATUS_LABELS_COLORS_CLASSNAMES: OrderStatusLabelColorClassName[] = [
    {
        status: 'placed',
        label: 'Placed',
        color: '#7A8599',
        className: 'order-status-badge-placed',
        classNameText: 'order-status-text-placed',
    },
    {
        status: 'accepted',
        label: 'Accepted',
        color: getCSSVariableValue('--bs-primary'),
        className: 'badge-primary',
        classNameText: 'text-primary',
    },
    {
        status: 'executing',
        label: 'Executing',
        color: getCSSVariableValue('--bs-warning'),
        className: 'badge-warning',
        classNameText: 'text-warning',
    },
    {
        status: 'executed',
        label: 'Executed',
        color: getCSSVariableValue('--bs-success'),
        className: 'badge-success',
        classNameText: 'text-success',
    },
    {
        status: 'scheduled',
        label: 'Scheduled',
        color: getCSSVariableValue('--bs-info'),
        className: 'badge-info',
        classNameText: 'text-info',
    },
    {
        status: 'rejected',
        label: 'Rejected',
        color: getCSSVariableValue('--bs-danger'),
        className: 'badge-danger',
        classNameText: 'text-danger',
    }
];

export function getOrderStatusProps(status: string): OrderStatusLabelColorClassName | undefined {
    const result = ORDER_STATUS_LABELS_COLORS_CLASSNAMES.find(item => item.status === status);
    return result;
};
